import {
    faUser,
    IconName,
    fas,
    faSadTear
} from "@fortawesome/pro-solid-svg-icons";
import * as React from "react";
import { HeaderContainer } from "./HeaderContainer";
import { Col, Row } from "jsxstyle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SemiBold } from "./Styling";

export class GenericError extends React.Component<{}, {}> {
    public render() {
        return (
            <Col
                height="100%"
                alignItems="center"
                textAlign="center"
                color="white"
            >
                <FontAwesomeIcon icon={faSadTear} size="5x" />
                <SemiBold marginTop={16} marginBottom={16}>
                    Oh no! Something went wrong!
                </SemiBold>
                <p style={{ lineHeight: "29px" }}>
                    Try refreshing your browser and repeat the last few things
                    you did before this.
                </p>
                <p>
                    If the problem persists, please contact{" "}
                    <a
                        style={{ color: "white" }}
                        href="mailto:support@laud-media.com"
                    >
                        support@laud-media.com
                    </a>
                    .
                </p>
            </Col>
        );
    }
}



// WEBPACK FOOTER //
// ./src/GenericError.tsx